<template>
  <div>
    <el-card class="mb-24">
      <div class="title card-header" slot="header">
        {{ $t('personal::open-contract::my-card') }}
        <el-button type="text" @click="cardVisible = true">{{ $t('personal::open-contract::cardManager') }}</el-button>
      </div>
      <div class="card-list">
        <div class="card-item card-add" @click="addCard" v-if="cards.length < 5">
          <i class="iconfont iconadd"></i>
          <p>{{ $t('personal::open-contract::pleaseAdd') }}</p>
        </div>
        <div class="card-item card-type" v-for="item in cards" :key="item.id">
          <img style="height: 20px" :src="filterImg(item.cardBrand)" />
          <p class="card-number">
            <span v-for="i in 3" :key="i">****</span>
            <span>{{ item.cardNum }}</span>
          </p>
          <img v-if="item.defaulted" class="default-card" src="../../../assets/images/card-pay.png" />
        </div>
      </div>
    </el-card>
    <el-card class="mb-24" v-if="user.combo && !user.combo.isTrial && !user.isExpired">
      <div class="title card-header" slot="header">
        <div class="title">
          {{ $t('personal::my-contract::subscribePlan') }}
          <span class="tips">{{ $t('personal::my-contract::subscribeTips') }}</span>
        </div>
        <div v-if="subscribe.id">
          <el-button type="text" @click="changeSubscribe">{{ $t('personal::my-contract::changeSubscribe') }}</el-button>
          <el-button type="text" @click="cancleVisible = true">
            {{ $t('personal::my-contract::offSubscribe') }}
          </el-button>
        </div>
      </div>
      <template v-if="subscribe">
        <div class="subscribe-content" v-if="subscribe.id">
          <div class="subscribe-title">
            {{ subscribe.comboName }}
            <span class="subscribe-type">{{ payTypeMap[subscribe.priceType] }}</span>
          </div>
          <p class="subscribe-line">
            <span>{{ $t('personal::my-contract::subActiveTime') }}</span>
            <span>{{ subscribe.activeTime }}</span>
          </p>
          <p class="subscribe-line">
            <span>{{ $t('personal::my-contract::subCommissionRatio') }}</span>
            <span>{{ subscribe.commissionRatio }}%</span>
          </p>
          <p class="subscribe-line">
            <span>{{ $t('personal::my-contract::subShopQuantity') }}</span>
            <span>{{ subscribe.shopQuantity }}个</span>
          </p>
        </div>
        <div class="subscribe-wrap" v-else>
          <el-button
            type="primary"
            @click="
              $router.push({
                path: '/subscribe',
                query: {
                  grade: detail.grade,
                },
              })
            "
          >
            {{ $t('personal::my-contract::openSubscribe') }}
          </el-button>
        </div>
      </template>
    </el-card>
    <el-card>
      <div class="title card-header" slot="header">
        {{ $t('menu::contract-manager::my-contract') }}
      </div>
      <div class="mb-16">
        <el-button :type="tab === 1 ? 'primary' : ''" @click="changeTab(1)">
          {{ $t('personal::open-contract::nowCombo') }}
        </el-button>
        <el-button :type="tab === 0 ? 'primary' : ''" @click="changeTab(0)">
          {{ $t('personal::open-contract::comboList') }}
        </el-button>
      </div>
      <div v-show="tab === 0">
        <z-table
          :data="orderData"
          :columns="orderColumns"
          :pagination.sync="pagination"
          @page-change="getSubscriptionsList"
        >
          <template #operate="{ row }">
            <el-button type="text" @click="paynow(row)" v-if="row.status == 1">
              {{ $t('personal::open-contract::payNow') }}
            </el-button>
          </template>
        </z-table>
      </div>
      <div v-show="tab === 1">
        <div v-if="!!detail">
          <div class="contract-info mb-24">
            <div class="contract-title">
              {{ $t('personal::my-contract::合约信息') }}
            </div>
            <div>
              <div class="info-wrap">
                <div class="left-item">
                  {{ $t('personal::my-contract::账户信息') }}：{{ $dataCheck(detail.userAccount) }}
                </div>
                <div>
                  {{ $t('personal::my-contract::套餐价格') }}：{{
                    detail.price && detail.paymentType ? `$${detail.price}/${filterUnit(detail.paymentType)}` : '--'
                  }}
                </div>
              </div>
              <div class="info-wrap">
                <div class="left-item">
                  {{ $t('personal::my-contract::购买套餐') }}：{{ $dataCheck(detail.comboName) }}
                  <el-button
                    type="text"
                    @click="showUpgradeDialog"
                    style="padding: 0px"
                    v-show="detail.paymentType !== 'm' && !detail.trial"
                  >
                    {{ $t('personal::contract::升级套餐') }}
                  </el-button>
                </div>
                <div>
                  {{ $t('personal::my-contract::套餐有效期') }}：
                  <span v-if="detail.comboCycleUnit">
                    {{
                      detail.comboCycleQuantity > 0
                        ? `${detail.comboCycleQuantity}${filterUnit(detail.comboCycleUnit)}${
                            detail.extraValidity || ''
                          }`
                        : '无期限'
                    }}
                    <!-- <span v-if="detail.comboCycleQuantity > 0 && detail.giveDay > 0">
                      +{{ detail.giveDay }}{{ $t('personal::open-contract::giveDay') }}
                    </span> -->
                  </span>
                  <span v-else>--</span>
                </div>
              </div>
              <div class="info-wrap">
                <div class="left-item">
                  {{ $t('personal::my-contract::付款方式') }}：{{ $dataCheck(payTypeMap[detail.paymentType]) }}
                </div>
                <div>{{ $t('personal::my-contract::合约状态') }}：{{ $dataCheck(statusMap[detail.status]) }}</div>
              </div>
              <div class="info-wrap">
                <div class="left-item">
                  {{ $t('personal::my-contract::GMV抽佣比例') }}：{{
                    detail.commissionRatio ? detail.commissionRatio + '%' : '--'
                  }}
                </div>
                <div>
                  {{ $t('personal::open-contract::GMVFirstYear') }}：{{
                    detail.gmvFirstFreeCommission ? `$${formatNumberMix(detail.gmvFirstFreeCommission / 10000)}万` : '-'
                  }}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="contract-title">
              {{ $t('personal::my-contract::合约信息') }}
              <el-button
                type="text"
                :style="{ color: active == 0 ? '#0560fd' : ' #999999', marginLeft: '24px' }"
                @click="active = 0"
              >
                {{ $t('personal::open-contract::serviceOrder') }}
              </el-button>
              <el-button type="text" :style="{ color: active == 1 ? '#0560fd' : ' #999999' }" @click="active = 1">
                {{ $t('personal::open-contract::commissionOrder') }}
              </el-button>
            </div>
            <z-table :data="tableData.filter(i => i.type === active)" :columns="columns" :pagination="false"></z-table>
          </div>
        </div>
        <div v-else>
          <emptyCard
            :data="{
              title: $t('personal::my-contract::empty_title'),
              img: require('@/assets/images/expired.png'),
              buttons: [{ click: onBindSetting, text: $t('personal::my-contract::buy') }],
            }"
          ></emptyCard>
        </div>
      </div>
    </el-card>
    <CardManager v-model="cardVisible" :cards="cards" @success="getCards"></CardManager>
    <AddCard v-model="addVisible" @success="getCards"></AddCard>
    <stripePay v-model="visible" :selectPayment="payment" :selectCombo="combo" @success="refreshDetail"></stripePay>
    <el-dialog title="取消订阅确定" :visible.sync="cancleVisible" width="440px">
      <div class="cancle-tips">
        {{ $t('personal::my-contract::cancleContractTips') }}
      </div>
      <div slot="footer">
        <el-button @click="cancleVisible = false">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button type="primary" :loading="cancleLoading" @click="cancleSubscribe">
          {{ $t('system::common::btn::confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <Result v-model="resultVisible" :result="result"></Result>
    <UpgradeDialog v-model="isShowDialog" :detail="detail" :cards="cards" @success="refreshDetail"></UpgradeDialog>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { formatNumberMix } from '@/utils'
import { columns, statusMap, orderColumns, payTypeMap, filterImg } from './config'
import {
  getContractDetail,
  getCardsList,
  getSubscriptionsList,
  getUserSubscribe,
  postCancleSubscribe,
} from '@/server/personal/contract'
import CardManager from './components/card-manager.vue'
import AddCard from './components/addCard.vue'
import stripePay from '@/views/personal-center/contract-management/components/stripePay'
import Result from './components/result.vue'
import UpgradeDialog from './components/upgradeDialog.vue'
export default {
  name: 'myContract',
  components: { CardManager, AddCard, stripePay, Result, UpgradeDialog },
  data() {
    return {
      columns,
      statusMap,
      payTypeMap,
      tableData: [],
      orderData: [],
      detail: {},
      active: 0,
      tab: 1,
      visible: false,
      cardVisible: false,
      addVisible: false,
      pagination: {
        pageSize: 5,
        pageNum: 1,
        total: 0,
      },
      cards: [],
      clientSecret: '',
      combo: '',
      payment: {},
      subscribe: {},
      cancleVisible: false,
      cancleLoading: false,
      resultVisible: false,
      result: {},
      isShowDialog: false,
    }
  },
  created() {
    this.getDetail()
    this.getCards()
    this.getSubscriptionsList()
    this.getUserSubscribe()
  },
  mounted() {
    window.eventBus.$on('refreshSubscribe', obj => {
      this.getUserSubscribe()
    })
  },
  methods: {
    filterImg,
    formatNumberMix,
    refreshDetail() {
      this.getDetail()
      this.getSubscriptionsList()
      this.getUserSubscribe()
    },
    // 获取订阅信息
    async getUserSubscribe() {
      const { data } = await getUserSubscribe()
      if (data.code === this.$code) {
        if (data.data.activeTime) {
          data.data.activeTime = moment(data.data.activeTime).format('YYYY-MM-DD')
        }
        this.subscribe = data.data
      }
    },
    // 获取套餐列表
    async getSubscriptionsList() {
      const { data } = await getSubscriptionsList({
        ...this.pagination,
      })
      if (data.code === this.$code) {
        this.orderData = (data.data && data.data.items) || []
        this.pagination.total = (data.data && data.data.totalCount) || 0
      }
    },
    async getCards() {
      const { data } = await getCardsList()
      if (data.code === this.$code) {
        this.cards = data.data || []
      }
    },
    onBindSetting() {
      this.$router.push('/open-contract')
    },
    async getDetail() {
      const { data } = await getContractDetail()
      if (data.code === this.$code) {
        this.detail = data.data || ''
        this.tableData = (data.data && data.data.orders) || []
      }
    },
    filterUnit(key) {
      switch (key) {
        case 'y':
          return this.$t('personal::my-contract::年')
        case 'm':
          return this.$t('personal::my-contract::月')
        case 'd':
          return this.$t('personal::my-contract::天')
      }
    },
    async addCard() {
      this.addVisible = true
    },
    paynow(row) {
      this.combo = {
        ...row,
        priceInfo: {
          ...row,
          cycleUnit: row.paymentType,
        },
      }
      this.payment = this.$deepClone(row)
      this.visible = true
    },
    changeTab(tab) {
      this.tab = tab
      if (tab === 0) this.getSubscriptionsList()
      if (tab === 1) this.getDetail()
    },
    changeSubscribe() {
      this.$router.push({
        path: '/subscribe',
        query: {
          id: this.subscribe.id,
          priceId: this.subscribe.priceId,
          grade: this.detail.grade,
        },
      })
    },
    // 取消订阅
    async cancleSubscribe() {
      this.cancleLoading = true
      const { data } = await postCancleSubscribe(this.subscribe.id)
      this.cancleLoading = false
      if (data.code === this.$code) {
        this.cancleVisible = false
        this.resultVisible = true
        this.result = {
          close: false,
          iconClass: 'el-icon-success',
          resultTitle: this.$t('personal::my-contract::offSuccess'),
          resultTips: this.$t('personal::my-contract::offSuccess-tips'),
          buttons: [
            {
              text: this.$t('personal::my-contract::know'),
              click: () => {
                this.resultVisible = false
                this.getUserSubscribe()
              },
            },
          ],
        }
      }
    },
    showUpgradeDialog() {
      this.isShowDialog = true
    },
  },
  watch: {
    '$route.query': {
      handler(val) {
        this.tab = Number(val.tab || 1)
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState(['user']),
    orderColumns() {
      if (this.orderData.some(item => item.status == 1)) {
        return orderColumns
      }
      return orderColumns.slice(0, -1)
      // return orderColumns
    },
  },
}
</script>

<style scoped lang="scss">
/deep/.el-card .el-card__header {
  border-bottom: 1px solid #dcdfe6;
}
.info-wrap {
  display: flex;
  margin: 24px 0;
  &:first-child {
    margin-top: 8px;
  }
  &:last-child {
    margin-bottom: 8px;
  }
  .left-item {
    width: 300px;
  }
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .tips {
    font-size: 12px;
    color: #666666;
    margin-left: 12px;
  }
}
.card-list {
  display: flex;
  overflow: auto;
  .card-item {
    min-width: 200px;
    width: 200px;
    height: 130px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid transparent;
    margin-right: 16px;
    box-sizing: border-box;
    &.card-add {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #0560fd;
      border: 1px solid #eeeeee;
      cursor: pointer;
      .iconadd {
        font-size: 20px;
        color: #0560fd;
        margin-bottom: 10px;
      }
    }
    &.card-type {
      position: relative;
      background: url('../../../assets/images/card-bg.png');
      background-repeat: no-repeat;
      background-size: 100%;
      padding: 20px 12px;
      box-sizing: border-box;
      .card-number {
        margin-top: 18px;
        letter-spacing: 2px;
        color: #010517;
        font-size: 13px;
        text-align: center;
        span {
          margin-left: 8px;
          &:first-child {
            margin-left: 0;
          }
        }
      }
      .default-card {
        position: absolute;
        right: -2px;
        top: -2px;
        width: 49px;
        height: 49px;
      }
    }
  }
}
.contract-info {
  padding: 24px;
  background: #f9f9f9;
  border-radius: 6px;
}
.contract-title {
  font-size: 16px;
  font-weight: bold;
  color: #010517;
  margin-bottom: 24px;
}
.subscribe-wrap {
  width: 100%;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('../../../assets/images/cards/subscribe-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.subscribe-content {
  width: 380px;
  height: 166px;
  box-sizing: border-box;
  background: url('../../../assets/images/cards/subscribe.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #fff;
  padding: 24px;
  .subscribe-title {
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    display: flex;
    align-items: center;
    span {
      display: inline-block;
      width: 40px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      margin-left: 8px;
      background: #ffffff;
      border-radius: 2px;
      font-weight: bold;
      color: #0560fd;
      font-size: 12px;
    }
  }
  .subscribe-line {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #ffffff;
    margin-top: 14px;
  }
}
.cancle-tips {
  font-size: 14px;
  color: #010517;
  line-height: 30px;
  text-align: center;
}
</style>
